import { useClearRefinements, useCurrentRefinements } from "react-instantsearch";
import CloseIcon from "./ui/CloseIcon";

const prettyLabels: Record<string, string> = {
  "named_tags.category": "Category",
  "product_type": "Type",
  "meta.custom.rooms": "Room",
  "meta.custom.colours": "Colour",
  "vendor": "Brand",
  "named_tags.designer": "Designer",
  "named_tags.range": "Range",
  "named_tags.sale": "Sale", // item.label = "named_tags_names"
  "named_tags_names:sale": "On Sale",  // item.label = "named_tags_names"
  "meta.custom.best_seller": "Best Sellers", // item.label = "meta.custom.best_seller"
  "tags:Ready to ship": "Ready To Ship", // item.label = "tags"
  "tags:Commercial": "Commercial", // item.label = "tags"
  "named_tags.availability:Shop online": "Shop Online", // item.label = "named_tags.availability"
};

export function CurrentFilters() {
  const { items = [] } = useCurrentRefinements();
  const { hasRefinements, canRefine, refine } = useClearRefinements();

  // console.log("Current filters:", items);

  return (
    <ul className="tw-inline-flex tw-flex-wrap [&>li]:md:tw-mr-4">
      {items.map((item) =>
        item.refinements.map((refinement) => (
          <li
            key={[item.indexName, item.label, refinement.label].join('/')}
            className="tw-text-sm tw-font-normal tw-flex tw-items-center tw-gap-1 tw-cursor-pointer tw-p-1 md:tw-p-3 tw-text-search-grey hover:tw-text-black"
            onClick={() => item.refine(refinement)}
          >
            <span>{prettyLabels[item.label]? `${prettyLabels[item.label]}` : ""}</span>
            <span>{item.attribute !== "meta.custom.best_seller" && typeof refinement.label === "string"
              ? refinement.label.charAt(0).toUpperCase() + refinement.label.slice(1)
              : ""}</span>
            <span className="tw-p-2"><CloseIcon /></span>
          </li>
        ))
      )}

      {hasRefinements && canRefine && (
        <li
          className="tw-text-sm tw-font-normal tw-flex tw-items-center tw-gap-1 tw-cursor-pointer tw-p-1 md:tw-p-3 tw-text-search-grey hover:tw-text-black"
          onClick={() => refine()}
        >
          Clear All
        </li>
      )}

    </ul>
  );
}
